import React from 'react'
import '../home/home.css'
const ScrollDown = () => {
  


  return (
<div className="home__scroll" >
        <a href="#about" className="home__scroll-button button--flex">
        <div className="scroll" > </div>
        </a>
        <div className="home__scroll-name">Scroll Down </div>
        <i className="uil uil-arrow-down home__scroll-arrow"></i>
    </div>
  )
}

export default ScrollDown